export { default as FactCard } from './FactCard'
